import { useMutation } from '@tanstack/react-query';
import { sendFeedback } from 'shared/services/backend-api';

export const useSendFeedbackMutation = () =>
  useMutation({
    mutationFn: (message: string) => sendFeedback(message),
  });
